import useSWRImmutable from "swr/immutable";

import { fetchTicketRedeemGroups } from "./fetchTicketRedeemGroups";

/**
 * 指定した ticketId(=productId) の手動もぎりが無効化されているか判定する。
 * true を返した場合、利用側ではQRの上にオーバーレイを重ねてチェックイン操作を
 * 無効化する(QR要素自体は描画されたまま)。
 *
 * - ticketId を ticketIds に含む ticketRedeemGroups が1つも無い → false(無効化しない)
 * - 該当グループが複数ある場合、全ての isTicketRedeemingEnabled が false の時だけ true(無効化)。
 *   1つでも isTicketRedeemingEnabled が true のグループがあれば false(無効化しない)。
 * - データ未取得(ロード中 / fetch失敗) → false にフォールバックし、誤って無効化しない。
 */
export const useIsTicketRedeemingDisabled = (
  ticketId: string | undefined
): boolean => {
  // 全カードで同一key → SWRがdedupeするため全件fetchは1回で済む
  const { data: groups } = useSWRImmutable(
    "ticketRedeemGroups",
    fetchTicketRedeemGroups
  );

  if (!ticketId || !groups) return false;

  const matchedGroups = groups.filter((group) =>
    group.ticketIds.includes(ticketId)
  );
  if (matchedGroups.length === 0) return false;

  return matchedGroups.every(
    (group) => group.isTicketRedeemingEnabled === false
  );
};
